import * as actions from '../constants/actions';

/**
 * Sets installations' headers.
 *
 * @param {Array} headers
 *
 * @return {*}
 */
export const setInstallationsHeaders = headers => ({
    type: actions.SET_INSTALLATIONS_HEADERS,
    headers,
});

/**
 * Set installations' rows .
 *
 * @param {Array} rows
 *
 * @return {*}
 */
export const setInstallationsRows = rows => ({
    type: actions.SET_INSTALLATIONS_ROWS,
    rows,
});
